/* global ResizeObserver */
import { useEffect, useRef } from 'react'

export const useImageBackground = (aspectRatio, backgroundColor = '#FFEBE7') => {
  const containerRef = useRef(null)

  useEffect(() => {
    const setContainerHeight = () => {
      if (aspectRatio && containerRef.current) {
        const resolution = aspectRatio.split(':')
        if (resolution.length === 2) {
          const ratio = parseFloat(resolution[0]) / parseFloat(resolution[1])
          const containerWidth = containerRef.current.getBoundingClientRect().width

          if (containerWidth) {
            const renderHeight = parseInt(containerWidth / ratio)
            containerRef.current.style.height = renderHeight + 'px'
            containerRef.current.style.background = backgroundColor
          }
        }
      }
    }

    // Set height immediately
    setContainerHeight()

    // Set height on window resize
    const handleResize = () => {
      setContainerHeight()
    }

    window.addEventListener('resize', handleResize)

    // Use ResizeObserver for more accurate container size changes
    let resizeObserver
    if (containerRef.current && window.ResizeObserver) {
      resizeObserver = new ResizeObserver(() => {
        setContainerHeight()
      })
      resizeObserver.observe(containerRef.current)
    }

    return () => {
      window.removeEventListener('resize', handleResize)
      if (resizeObserver) {
        resizeObserver.disconnect()
      }
    }
  }, [aspectRatio, backgroundColor])

  return containerRef
}



// WEBPACK FOOTER //
// ./src/react-component/Hooks/useImageBackground.js